import React from "react";
import { Package } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function TrackSearch({ trackOrderById }) {
  const [trackingOrderId, setTrackingOrderId] = React.useState("");
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-20">
      <div className="max-w-md w-full">
        <Package className="w-16 h-16 mx-auto mb-6" />
        <h1 className="text-4xl font-bold text-center mb-4">Track Your Order</h1>

        <input
          type="text"
          value={trackingOrderId}
          onChange={(e) => setTrackingOrderId(e.target.value.toUpperCase())}
          placeholder="Enter Order ID"
          className="w-full border border-gray-300 px-4 py-3 rounded mb-4"
        />

        <button
          onClick={() => trackOrderById(trackingOrderId)}
          className="w-full bg-black text-white py-3 rounded font-medium hover:bg-gray-800 transition"
        >
          Track Order
        </button>
      </div>
    </div>
  );
}
